import { CartFreeShippingInterface } from '@qlevr/shared/interfaces';

export function getFreeShippingThresholdByCountry(thresholds: CartFreeShippingInterface['threshold'] | undefined, country: string): number | null {
  if(!thresholds) return null;

  return thresholds[country.toLocaleLowerCase()];
}
